/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';

// Relements
import Animate from 'relements/build/esm/layouts/animate';
import Box from 'relements/build/esm/ui/box';
import Button from 'relements/build/esm/ui/button';
import Text from 'relements/build/esm/input/text';
import Dropdown from 'relements/build/esm/input/dropdown';
import Loader from 'relements/build/esm/decorators/loader';
import ClosingCategoriesIcon from 'relements/build/esm/ui/icons/ClosingCategoriesIcon';
import ContentManagementIcon from 'relements/build/esm/ui/icons/ContentManagementIcon';
import WarningIcon from 'relements/build/esm/ui/icons/WarningIcon';
import TickIconV2 from 'relements/build/esm/ui/icons/TickIconV2';

// Utils
import connection from '@src/connection';

// import Action
import { copyPaste } from 'actions/CopyAction';
import { createAlert } from 'actions/BotActions';
import { getAllBusinessList } from 'actions/BusinessManagerActions';

// import Alerts from MogamboConstants
import { AlertTypes } from 'constants/MogamboConstants';

// import Store
import BusinessStore from 'stores/BusinessStore';
import BotStore from '@src/store';

// Local
import CopyAPIResponse from './components/CopyAPIResponse';

import './copy-paste.scss';

function getStateFromStores() {
  return {
    businessList: BusinessStore.getBusinessList(),
    partnerList: BusinessStore.getPartnerIdMap(),
    domainList: BusinessStore.getBotList(),
    templateDomainList: BusinessStore.getTemplateBotList(),
    userPartnersList: BotStore.getUserPartnersList(),
  };
}

@Loader({})
@connection([BusinessStore], getStateFromStores)
export default class CopyPaste extends React.Component {
  constructor() {
    super();
    this.state = {
      selected: 'copy_everything',
      page: 'selectBusinessPartner',
      copyNodeUserSays: true,
      copyNodeBotSays: true,
      copyNodeConnections: true,
      copyDomainGeneralNodes: true,
      copyGeneralResponses: true,
      copyStoryGeneralNodes: true,
      copyOtherSubstoryConnectedNodes: true,
      currentBusiness: { value: '', title: '' },
      currentPartner: { value: '', title: '' },
      response: {},
      targetDomain: '',
      targetStory: '',
      allPartners: [],
    };
  }

  componentDidMount() {
    if (!this.props.businessList && this.props.copyType !== 'domain') {
      this.props.activateLoader();
      getAllBusinessList(this.props.deactivateLoader);
    } else if (this.props.copyType === 'domain') {
      this.formatPartnerDropdownOptions();
    }
  }

  render() {
    const { page } = this.state;
    return (
      <Box style={{ width: '100%', padding: 0 }}>
        {page === 'selectBusinessPartner' &&
          this._renderBusinessPartnerOptions()}
        {page === 'loading' && this._renderLoadingPage()}
        {page === 'final' && this._renderCopyPasteAPIResponse()}
      </Box>
    );
  }

  formatPartnerDropdownOptions = () => {
    const partners = this.props.userPartnersList;
    const allPartnersList = Object.keys(partners).map((key) => ({
      value: partners[key].partner_name,
      title: partners[key].partner_name,
    }));
    this.setState({
      allPartners: allPartnersList,
    });
  };

  _renderBusinessPartnerOptions = () => {
    const allBotOptions = this.props.domainList.map((bot) => {
      return {
        value: bot,
        title: bot,
      };
    });
    const templateBotOptions = this.props.templateDomainList.map((bot) => {
      return {
        value: bot,
        title: `${bot} (Template)`,
      };
    });
    const defaultBotOptions = [
      {
        value: '',
        title: '',
      },
    ]
      .concat(allBotOptions)
      .concat(templateBotOptions);

    const botNamehasError = !this._validateBotName(this.state.targetDomain);
    const partnerNamehasError = !this.state.currentPartner.value;

    const hasError = botNamehasError || partnerNamehasError;

    return (
      <Box style={{ padding: 0, width: 552, flexDirection: 'column' }}>
        {this.props.copyType === 'domain' && (
          <>
            <Animate entry="fade-down">
              <div style={{ padding: '22px 16px' }}>
                <Text
                  themed
                  label="Name of the new bot"
                  error={
                    botNamehasError &&
                    'Bot name can contain only lower case characters, numbers, underscore and space.'
                  }
                  value={this.state.targetDomain}
                  onChange={this._onDomainChange}
                />

                <br />
                <Dropdown
                  themed
                  withSearch
                  label="Account"
                  value={this.state.currentPartner}
                  optionKey="value"
                  options={this.state.allPartners}
                  onChange={this._onActivePartnerChanged}
                  attachTo={this.props.modalRef}
                />
              </div>
            </Animate>
            <Box
              style={{
                padding: '10px 16px',
                justifyContent: 'flex-end',
                columnGap: 8,
                borderTop: '1px solid #d5d5d5',
              }}
            >
              <Button
                onClick={this._moveAhead}
                themed
                variant={hasError ? 'disabled' : 'primary'}
                disabled={hasError}
              >
                Continue
              </Button>
            </Box>
          </>
        )}

        {this.props.copyType === 'story' && (
          <div>
            <Button
              type={Button.TYPES.SECONDARY}
              onClick={this._moveBack}
              className="text-header"
            >
              {'< Back'}
            </Button>
            <div className="text-header text-input-form input-header">
              Create your Destination Story:
            </div>
            <div className="text-header text-input-form">
              Name of the new Story
            </div>
            <Text
              error={
                !this._validateBotName(this.state.targetStory) &&
                'Bot name can contain only lower case characters, numbers, underscore and space.'
              }
              value={this.state.targetStory}
              onChange={this._onStoryChange}
            />

            <div className="text-header text-input-form">
              Select the bot in which this story go:
            </div>
            <Dropdown
              withSearch
              value={{
                value: this.state.targetDomain,
                title: this.state.targetDomain,
              }}
              optionKey="value"
              options={defaultBotOptions}
              onChange={(val) => this._onDomainChange(val.value)}
            />

            <div className="disclaimer-bottom">
              It’s recommended to select/create a bot in a different business.
              Having 2 Skill Sets with identical ‘user says’ within the same
              business will confuse system. If still necessary, you should
              change the ‘user says’ later.
            </div>
            <Box
              style={{
                padding: '10px 16px',
                justifyContent: 'flex-end',
                borderTop: '1px solid #d5d5d5',
              }}
            >
              <Button
                type={Button.TYPES.PRIMARY}
                onClick={this._moveAhead}
                themed
              >
                Continue
              </Button>
            </Box>
          </div>
        )}
      </Box>
    );
  };

  _moveAhead = () => {
    if (this.state.page === 'selectBusinessPartner') {
      if (this.props.copyType === 'domain' && this.state.targetDomain === '') {
        createAlert('Please Enter the name of the Duplicated Bot');
        return;
      }

      if (
        this.props.copyType === 'domain' &&
        !/^[a-z0-9_ ]+$/.test(this.state.targetDomain)
      ) {
        createAlert(
          'Bot name can contain only lower case characters, numbers, underscore and space.',
          undefined,
          AlertTypes.NEGATIVE
        );
        return;
      }

      if (
        this.props.copyType === 'domain' &&
        !this.state.currentPartner.value
      ) {
        createAlert(
          'Please select an account for the Bot Duplication',
          undefined,
          AlertTypes.NEGATIVE
        );
        return;
      }

      if (this.props.copyType === 'story' && this.state.targetStory === '') {
        createAlert('Please Enter the name of the copied Story');
        return;
      }

      if (this.props.copyType === 'story' && this.state.targetDomain === '') {
        createAlert('Please Select the Bot of the copied Story');
        return;
      }

      const { state } = this;
      const { props } = this;
      let payload = {};
      if (props.copyType === 'domain') {
        payload = {
          copy_component: props.copyType,
          copying_options: {
            copy_node_user_says: state.copyNodeUserSays,
            copy_node_bot_says: state.copyNodeBotSays,
            copy_node_connections: state.copyNodeConnections,
            copy_domain_general_nodes: state.copyDomainGeneralNodes,
            copy_story_general_nodes: state.copyStoryGeneralNodes,
            copy_general_responses: state.copyGeneralResponses,
            partner: state.currentPartner.value,
            business_name: state.targetDomain.toLowerCase(),
            business_via_name: `${state.targetDomain
              .toLowerCase()
              .replace(/_/g, '')
              .replace(/ /g, '')}channel`,
          },
          data: {
            domain: [{ from: props.name, to: state.targetDomain }],
          },
        };
      } else if (props.copyType === 'story') {
        payload = {
          copy_component: props.copyType,
          copying_options: {
            copy_node_user_says: state.copyNodeUserSays,
            copy_node_bot_says: state.copyNodeBotSays,
            copy_node_connections: state.copyNodeConnections,
            copy_domain_general_nodes: false,
            copy_story_general_nodes: state.copyStoryGeneralNodes,
            copy_general_responses: false,
            partner: state.currentPartner.value,
            business_via_name: state.currentBusiness.value,
          },
          data: {
            domain: [
              {
                from: props.sourceDomain,
                to: state.targetDomain,
                story: [{ from: props.name, to: state.targetStory }],
              },
            ],
          },
        };
      }
      this.setState({ page: 'loading' });
      copyPaste(payload, this.state.selected, (response) => {
        this.setState({ page: 'final' });
        this.setState({ response });
      });
    }
  };

  _onActivePartnerChanged = (value) => {
    this.setState({
      currentPartner: value,
    });
  };

  _onBusinessChange = (value) => {
    this.setState({
      currentBusiness: value,
    });
    if (this.state.currentBusiness.partners) {
      this.setState({
        currentPartner: this.state.currentBusiness.partners[0].value,
      });
    }
  };

  _onDomainChange = (value) => {
    this.setState({
      targetDomain: this._cleanedBotName(value),
    });
  };

  _cleanedBotName = (value) => {
    return value.toLowerCase();
  };

  _validateBotName = (value) => {
    return /^[a-z0-9_ ]+$/.test(this._cleanedBotName(value));
  };

  _onStoryChange = (value) => {
    this.setState({
      targetStory: value,
    });
  };

  _renderLoadingPage = () => {
    return (
      <CopyAPIResponse
        text="Creating Duplicate Bot"
        subText="This might take a few seconds"
        loader
      />
    );
  };

  _renderCopyPasteAPIResponse = () => {
    const { response, targetDomain, targetStory } = this.state;
    const { copyType } = this.props;

    let titleText = 'Bot Duplication Failed';
    const subText = response.error;
    let icon = <WarningIcon iconColor="red.haptik" size="big" />;

    if (response.success) {
      if (copyType === 'domain') {
        titleText = `'${targetDomain}' Bot created!`;
      } else if (copyType === 'story') {
        titleText = `'${targetStory}' Skill Set Created !`;
      }
      icon = <TickIconV2 iconColor="green.haptik" size="big" />;
    }

    return <CopyAPIResponse text={titleText} subText={subText} icon={icon} />;
  };

  _closeModal = () => {
    this.setState({
      page: 'selectBusinessPartner',
    });
    this.props.onClose();
  };
}

CopyPaste.propTypes = {
  domainList: PropTypes.arrayOf(PropTypes.string),
  templateDomainList: PropTypes.arrayOf(PropTypes.string),
  businessList: PropTypes.arrayOf(PropTypes.object),
  partnerList: PropTypes.object,
  onClose: PropTypes.func,
  copyType: PropTypes.string,
  activateLoader: PropTypes.func,
  deactivateLoader: PropTypes.func,
  userPartnersList: PropTypes.arrayOf(PropTypes.object),
};
